var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "admin-plan-form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.proceed.apply(null, arguments)
        },
        keydown: function ($event) {
          return _vm.planForm.errors.clear($event.target.name)
        },
      },
    },
    [
      _c("div", { staticClass: "row admin-plan-form__row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-4 form-group" },
          [
            _c("label", { attrs: { for: "" } }, [
              _vm._v(_vm._s(_vm.trans("plan.name")) + " "),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.planForm.name,
                  expression: "planForm.name",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                name: "name",
                placeholder: _vm.trans("plan.name"),
              },
              domProps: { value: _vm.planForm.name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.planForm, "name", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("show-error", {
              attrs: { "form-name": _vm.planForm, "prop-name": "name" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-md-4 form-group" },
          [
            _c("label", { attrs: { for: "" } }, [
              _vm._v(_vm._s(_vm.trans("plan.code"))),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.planForm.code,
                  expression: "planForm.code",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                name: "code",
                placeholder: _vm.trans("plan.code"),
              },
              domProps: { value: _vm.planForm.code },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.planForm, "code", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("show-error", {
              attrs: { "form-name": _vm.planForm, "prop-name": "code" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-md-4 form-group" },
          [
            _c("label", { attrs: { for: "" } }, [
              _vm._v(_vm._s(_vm.trans("plan.max_student"))),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.planForm.max_student,
                  expression: "planForm.max_student",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                name: "max_student",
                placeholder: _vm.trans("plan.max_student"),
              },
              domProps: { value: _vm.planForm.max_student },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.planForm, "max_student", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("show-error", {
              attrs: { "form-name": _vm.planForm, "prop-name": "max_student" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group admin-plan-form__desc" },
        [
          _c("label", { attrs: { for: "" } }, [
            _vm._v(_vm._s(_vm.trans("plan.description"))),
          ]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.planForm.description,
                expression: "planForm.description",
              },
            ],
            staticClass: "form-control",
            attrs: {
              rows: "4",
              name: "description",
              placeholder: _vm.trans("plan.description"),
            },
            domProps: { value: _vm.planForm.description },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.planForm, "description", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("show-error", {
            attrs: { "form-name": _vm.planForm, "prop-name": "description" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { attrs: { for: "" } }, [
            _vm._v(_vm._s(_vm.trans("plan.features"))),
          ]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.planForm.features,
                expression: "planForm.features",
              },
            ],
            staticClass: "form-control",
            attrs: {
              rows: "6",
              name: "features",
              placeholder: _vm.trans("plan.features_placeholder"),
            },
            domProps: { value: _vm.planForm.features },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.planForm, "features", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("show-error", {
            attrs: { "form-name": _vm.planForm, "prop-name": "features" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "admin-plan-form__switches" }, [
        _c(
          "div",
          { staticClass: "admin-plan-form__switch-row" },
          [
            _c(
              "div",
              { staticClass: "admin-plan-form__switch-meta" },
              [
                _c("span", { staticClass: "admin-plan-form__switch-label" }, [
                  _vm._v(_vm._s(_vm.trans("plan.status"))),
                ]),
                _vm._v(" "),
                _c("show-tip", {
                  attrs: { type: "field", module: "plan", tip: "tip_status" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("switches", {
              attrs: { theme: "bootstrap", color: "success" },
              model: {
                value: _vm.planForm.is_active,
                callback: function ($$v) {
                  _vm.$set(_vm.planForm, "is_active", $$v)
                },
                expression: "planForm.is_active",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "admin-plan-form__switch-row" },
          [
            _c(
              "div",
              { staticClass: "admin-plan-form__switch-meta" },
              [
                _c("span", { staticClass: "admin-plan-form__switch-label" }, [
                  _vm._v(_vm._s(_vm.trans("plan.default"))),
                ]),
                _vm._v(" "),
                _c("show-tip", {
                  attrs: { type: "field", module: "plan", tip: "tip_default" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("switches", {
              attrs: { theme: "bootstrap", color: "success" },
              model: {
                value: _vm.planForm.is_default,
                callback: function ($$v) {
                  _vm.$set(_vm.planForm, "is_default", $$v)
                },
                expression: "planForm.is_default",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "admin-plan-form__switch-row" },
          [
            _c(
              "div",
              { staticClass: "admin-plan-form__switch-meta" },
              [
                _c("span", { staticClass: "admin-plan-form__switch-label" }, [
                  _vm._v(_vm._s(_vm.trans("plan.featured"))),
                ]),
                _vm._v(" "),
                _c("show-tip", {
                  attrs: { type: "field", module: "plan", tip: "tip_featured" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("switches", {
              attrs: { theme: "bootstrap", color: "success" },
              model: {
                value: _vm.planForm.is_featured,
                callback: function ($$v) {
                  _vm.$set(_vm.planForm, "is_featured", $$v)
                },
                expression: "planForm.is_featured",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.planForm.plan_prices, function (plan_price) {
        return _c(
          "div",
          { key: plan_price.currency.id, staticClass: "admin-plan-price-card" },
          [
            _c(
              "h4",
              { staticClass: "admin-plan-price-card__title" },
              [
                _c("admin-icon", {
                  staticClass: "mr-1",
                  attrs: { name: "rupee" },
                }),
                _vm._v(
                  _vm._s(
                    plan_price.currency.name +
                      " (" +
                      plan_price.currency.symbol +
                      ")"
                  )
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(plan_price.frequencies, function (frequency) {
                return _c(
                  "div",
                  {
                    key: frequency.payment_frequency.id,
                    staticClass: "col-12 col-sm-6 form-group",
                  },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(_vm._s(frequency.payment_frequency.name)),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: frequency.amount,
                          expression: "frequency.amount",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "number",
                        step: ".01",
                        name: _vm.getAmountFieldName(plan_price, frequency),
                        placeholder: _vm.trans("plan.amount"),
                      },
                      domProps: { value: frequency.amount },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(frequency, "amount", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.planForm,
                        "prop-name": _vm.getAmountFieldName(
                          plan_price,
                          frequency
                        ),
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "admin-plan-form__actions" },
        [
          _c(
            "button",
            {
              staticClass:
                "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
              attrs: { type: "submit" },
            },
            [
              _c("admin-icon", { attrs: { name: "check" } }),
              _vm._v(" "),
              _vm.id
                ? _c("span", [_vm._v(_vm._s(_vm.trans("general.update")))])
                : _c("span", [_vm._v(_vm._s(_vm.trans("general.save")))]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.id,
                  expression: "id",
                },
              ],
              staticClass: "btn btn-sm admin-form-btn-cancel",
              attrs: { to: "/plan" },
            },
            [
              _c("admin-icon", {
                staticClass: "mr-1",
                attrs: { name: "close" },
              }),
              _vm._v(_vm._s(_vm.trans("general.cancel"))),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }